import { ProjectSubType, ProjectType } from '@prisma/client';
import { ImpactType } from '../impact/units';
import type {
  AdminCarbonAvoidanceProjectType,
  AdminCarbonRemovalProjectType,
  AdminHabitatRestorationProjectType,
} from './admin-projects';

type ProjectTypeWithTileImage =
  | AdminCarbonAvoidanceProjectType
  | AdminCarbonRemovalProjectType
  | AdminHabitatRestorationProjectType;

export const PROJECT_TILE_IMAGE_NAME_BY_TYPE: Record<ProjectTypeWithTileImage, string> = {
  [ProjectType.WETLANDS]: 'wetlands',
  [ProjectType.CAPTURE]: 'capture',
  [ProjectType.COMMUNITY]: 'community',
  [ProjectType.HOUSEHOLD_RETROFIT]: 'retrofit',
  [ProjectType.TRANSPORT]: 'transport',
  [ProjectType.GEOTHERMAL]: 'geothermal',
  [ProjectType.FORESTRY]: 'forest_protection',
  [ProjectType.RENEWABLES]: 'default',
  [ProjectType.AFFORESTATION_REFORESTATION_AND_REVEGETATION]: 'afforestation_reforestation_and_revegetation',
  [ProjectType.BLUE_CARBON]: 'blue_carbon',
  [ProjectType.BIOCHAR]: 'biochar',
  [ProjectType.DIRECT_AIR_CAPTURE]: 'default',
  [ProjectType.ENHANCED_ROCK_WEATHERING]: 'enhanced_rock_weathering',
  [ProjectType.REGENERATIVE_AGRICULTURE]: 'regenerative_agriculture',
  [ProjectType.WILDFLOWERS]: 'wildflowers',
  [ProjectType.SEAGRASS]: 'seagrass',
  [ProjectType.PEATLANDS]: 'peatlands',
  [ProjectType.RAINFOREST_PROTECTION]: 'rainforest_protection',
  [ProjectType.MARINE_PROTECTION_RESTORATION]: 'marine_protection_restoration',
};

export const PROJECT_TILE_IMAGE_NAME_BY_SUBTYPE: Record<ProjectSubType, string> = {
  [ProjectSubType.GLOBAL_REFORESTATION]: 'tree',
  [ProjectSubType.UK_REFORESTATION]: 'local/uk/uk-single-tree',
  [ProjectSubType.US_REFORESTATION]: 'local/usa/usa-single-tree',
  [ProjectSubType.BRAZIL_REFORESTATION]: 'local/braz/braz-single-tree',
  [ProjectSubType.AUSTRALIA_REFORESTATION]: 'local/aus/aus-single-tree',
  [ProjectSubType.HYDRO]: 'hydro',
  [ProjectSubType.WIND]: 'wind',
  [ProjectSubType.SOLAR]: 'solar',
  [ProjectSubType.BIOMASS]: 'biomass',
  [ProjectSubType.FOREST_PROTECTION]: 'forest_protection',
};

export const PROJECT_TILE_IMAGE_FOLDER_BY_IMPACT_TYPE = {
  [ImpactType.TREES]: 'trees',
  [ImpactType.CARBON_OFFSETS]: 'carbon_avoidance',
  [ImpactType.CARBON_REMOVAL]: 'carbon_removal',
  [ImpactType.HABITAT_RESTORATION]: 'habitat_restoration',
} satisfies Record<ImpactType, string>;
